import { useMutation } from "react-query";
import { useDispatch } from "react-redux";

import { getErrorMessage } from "helpers";
import { mappedUpdateReasonReviewData } from "mappers";
import { creditReviewDetailsService } from "services";
import { uiActions } from "store";
import { ErrorResponse } from "types";

const useUpdateReasonReviewMutation = (
	creditReviewId: string,
	refetchRiskExposureCalculatorInfo: Function,
) => {
	const dispatch = useDispatch();

	return useMutation(
		({
			formValues,
			setActionFormState,
		}: {
			formValues: { [key: string]: any };
			setActionFormState: Function;
		}) => {
			return creditReviewDetailsService.updateReasonForReviewInfo(
				creditReviewId,
				mappedUpdateReasonReviewData(formValues),
			);
		},

		{
			onSuccess(_result, { setActionFormState }) {
				refetchRiskExposureCalculatorInfo();
				setActionFormState(false);
			},
			onError(error: ErrorResponse) {
				dispatch(
					uiActions.showErrorNotification({
						title: getErrorMessage(error),
					}),
				);
			},
		},
	);
};

export default useUpdateReasonReviewMutation;
